import React from 'react';

import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './Card.scss';

const Card = ({
    children,
    className = '',
}: {
    children: React.ReactNode;
    className?: string;
}) => <div className={getClassName(styles.card, className)}>{children}</div>;

export default Card;
